import { useState } from "react";
import api from "../api/client";
import { getLang } from "../store/uiStore";
import "./SubmitSection.css";

export default function SubmitSection({ report }) {
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  const lang = getLang();

  const tr = {
    title:
      lang === "ru"
        ? "Подписание отчета"
        : "Имзои ҳисобот",

    fio:
      lang === "ru"
        ? "ФИО"
        : "Ному насаб",

    position:
      lang === "ru"
        ? "Должность"
        : "Вазифа",

    confirmation:
      lang === "ru"
        ? "Настоящим я подтверждаю достоверность предоставленной информации и принимаю ответственность, вытекающую из требований законодательства Республики Таджикистан"
        : "Бо ин тасдиқ менамоям, ки маълумоти пешниҳодшуда дуруст буда, масъулиятеро, ки аз талаботи қонунгузории Ҷумҳурии Тоҷикистон бармеояд, ба зимма мегирам",

    save:
      lang === "ru"
        ? "Сохранить"
        : "Сабт кардан",

    publish:
      lang === "ru"
        ? "Опубликовать"
        : "Фиристодан",

    sign:
      lang === "ru"
        ? "Подписать"
        : "Имзо кардан",

    return:
      lang === "ru"
        ? "Вернуть"
        : "Бозгардонидан",
  };

  const saveDraft = () => {
    alert("Сохранено");
  };

  const submit = async () => {

    const errors = [];

    // ❌ ФИО
    if (!name.trim()) {

      alert(
        lang === "ru"
          ? "Укажите ФИО"
          : "Ному насабро ворид кунед"
      );

      return;
    }

    // ❌ должность
    if (!position.trim()) {

      alert(
        lang === "ru"
          ? "Укажите должность"
          : "Вазифаро ворид кунед"
      );

      return;
    }

    // ❌ подтверждение
    if (!confirmed) {

      alert(
        lang === "ru"
          ? "Необходимо подтвердить достоверность данных"
          : "Тасдиқи дурустии маълумот зарур аст"
      );

      return;
    }

    report.values.forEach((v) => {

      // ❌ пустое значение
      if (
        v.value === null
        || v.value === undefined
        || v.value === ""
      ) {

        errors.push(
          `${v.indicator_name}: ${
            lang === "ru"
              ? "значение не заполнено"
              : "арзиш пур карда нашудааст"
          }`
        );

        return;
      }

      // ❌ не число
      if (!/^\d+$/.test(v.value)) {

        errors.push(
          `${v.indicator_name}: ${
            lang === "ru"
              ? "должно быть числом"
              : "бояд рақам бошад"
          }`
        );
      }

    });

    if (errors.length > 0) {

      alert(errors.join("\n"));

      return;
    }

    try {
      await api.post(`/api/report/${report.id}/submit/`, {
        name,
        position,
        confirmed,
      });

      alert(
        lang === "ru"
          ? "Отчет отправлен"
          : "Ҳисобот фиристода шуд"
      );

      window.location.reload();

    } catch (e) {

      console.error(e);

      const data = e.response?.data;

      // 🔥 обычный detail
      if (data?.detail) {

        alert(data.detail);

        return;
      }

      // 🔥 DRF validation object
      if (
        data &&
        typeof data === "object"
      ) {

        const messages = [];

        Object.entries(data).forEach(
          ([key, value]) => {

            if (Array.isArray(value)) {

              value.forEach((v) => {

                messages.push(
                  `${key}: ${v}`
                );

              });

            } else {

              messages.push(
                `${key}: ${value}`
              );

            }
          }
        );

        alert(messages.join("\n"));

        return;
      }

      alert(
        lang === "ru"
          ? "Ошибка отправки отчета"
          : "Хатогӣ ҳангоми ирсоли ҳисобот"
      );
    }

  };

  return (
    <section className="nizom-submit-section">
      <div className="nizom-submit-title-row">
        <div className="nizom-submit-title-accent" />
        <h3>{tr.title}</h3>
      </div>

      <div className="nizom-submit-fields">
        <div className="nizom-submit-field">
          <label htmlFor="report-sign-name">
            {tr.fio}
            <span>*</span>
          </label>
          <input
            id="report-sign-name"
            type="text"
            placeholder={tr.fio}
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="name"
          />
        </div>

        <div className="nizom-submit-field">
          <label htmlFor="report-sign-position">
            {tr.position}
            <span>*</span>
          </label>
          <input
            id="report-sign-position"
            type="text"
            placeholder={tr.position}
            value={position}
            onChange={(e) => setPosition(e.target.value)}
          />
        </div>
      </div>

      <label
        className={`nizom-confirmation ${confirmed ? "is-checked" : ""}`}
      >
        <input
          type="checkbox"
          checked={confirmed}
          onChange={(e) => setConfirmed(e.target.checked)}
        />

        <span className="nizom-confirmation-checkbox" aria-hidden="true">
          {confirmed && (
            <svg viewBox="0 0 24 24">
              <path
                d="M5 12.5l4.2 4.2L19 7"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>

        <span className="nizom-confirmation-copy">
          <span className="nizom-confirmation-label">
            {lang === "ru"
              ? "Подтверждение достоверности данных"
              : "Тасдиқи дурустии маълумот"}
          </span>
          <span className="nizom-confirmation-text">
            {tr.confirmation}
          </span>
        </span>
      </label>

      <div className="nizom-submit-actions">
        <button
          type="button"
          className="nizom-submit-button secondary"
          onClick={saveDraft}
        >
          {tr.save}
        </button>
        <button
          type="button"
          className="nizom-submit-button primary"
          onClick={submit}
        >
          {tr.publish}
        </button>
      </div>
    </section>
  );
}
